import EmptyDataCustom from "./EmptyDataCustom";

export default EmptyDataCustom;